/*eslint-disable*/
/*
 * 公共函数方法
 */
import vue from "@/main.js";
import Cookies from 'js-cookie'
import {
  cookieExpires
} from '@/api/config' // cookie保存的天数
import {
  getDeviceType
} from '@/common/getDeviceType/getDeviceType'
export const LANG_KEY = 'lzz_lzt_mis_lang'
/**
 * 存取token
 */

let baseToken = getURLParam("token");
let sysToken = getURLParam("sysToken");
let sysClient = getURLParam("sysClient");
Cookies.set("forest_token", baseToken);
Cookies.set("sys_token", sysToken);
Cookies.set("sys_client", sysClient);
export const TOKEN_KEY = 'forest_token'
export const TOKEN_TREE_KEY = 'sys_token'
export const TOKEN_TREE_CLIENT = 'sys_client'
export const getToken = () => {
  const token = getURLParam("token");
  if (token) {
    return token
  } else {
    return false
  }
};
// if (name == '/gushuGis' || name == '/gushuLzt' || name == '/gushuSlbk') {
//   let token = "";
//   if(type=='android'){
//     window.android.getInfo(200);
//   }else{
//     token = getURLParam("token");
//   }
//   return token
// } else 

/***获取登录信息**/
export async function getLoginInfo() {

  let arr = {};
  await vue.$api.User.loginInfo().then(res => {
    if (res.code == "1") {
      arr = res.data ? res.data : {};
    }
  });
  return arr;
}
/***获取用户信息**/
export async function getUserInfo(id) {
  let arr = {};
  await vue.$api.User.userInfo({
    uid: id,
  }).then(res => {
    if (res.code == "1") {
      arr = res.data ? res.data : {};
    }
  });
  return arr;
}

/***获取当前两级政区aeraList**/
export async function getaeraList(parentCode) {

  let arr = [];
  let arr2 = [];
  let dataArr = {};
  await vue.$api.User.areaList({
    parentCode: parentCode,
    depth: 1
  }).then(res => {
    if (res.code == "1") {
      for (let i = 0; i < res.data.children.length; i++) {
        let data = {};
        data.zqName = res.data.children[i].zqName;
        data.zqCode = res.data.children[i].zqCode;
        arr2.push(data);
      }
      dataArr = {
        zqName: res.data.zqName,
        zqCode: res.data.zqCode,
        children: arr2
      }
      arr.push(dataArr)
    }
  });
  return arr;
}
/***获取字典值**/
export async function getDictList(name) {

  let arr = "";
  await vue.$api.dict.dictList({
    parentCode: name,
  }).then(res => {
    if (res.code == "1") {
      arr = res.data ? res.data : "";
    }
  });
  return arr;
}



/**
 * 从URL中解析参数
 */
export const getParams = url => {
  const keyValueArr = url.split('?')[1].split('&')
  let paramObj = {}
  keyValueArr.forEach(item => {
    const keyValue = item.split('=')
    paramObj[keyValue[0]] = keyValue[1]
  })
  return paramObj
}

/** */
/** */
export function getURLParam(name) {
  //url后面存在#号 所以取值应在window.location.hash中获取
  let after = window.location.hash.split("?")[1] || window.location.href.split("?")[1];
  if (after) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = after.match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    } else {
      return null;
    }
  } else {
    return null
  }
}
// export function getdataUrlParam(name) {
//   //url后面没有存在#号 所以取值应在window.location.search中获取
//   var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
// 			var r = window.location.search.substr(1).match(reg);
// 			if(r != null) return decodeURI(r[2]);
// 			return null;
// }
/**
 * 判断一个对象是否存在key，如果传入第二个参数key，则是判断这个obj对象是否存在key这个属性
 * 如果没有传入key这个参数，则判断obj对象是否有键值对
 */
export const hasKey = (obj, key) => {
  if (key) {
    return key in obj
  } else {
    const keysArr = Object.keys(obj)
    return keysArr.length
  }
}

/**
 * 获取系统当前时间
 * @return: string
 */
export const getCurTime = () => {
  const date = new Date()
  return (
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate()) +
    ' ' +
    pad(date.getHours()) +
    ':' +
    pad(date.getMinutes()) +
    ':' +
    pad(date.getSeconds())
  )
}

/*
 *获取系统当前日期
 *@return: string
 */
export const getCurData = () => {
  const date = new Date()
  return (
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate())
  )
}
/*
 *标准时间转换成YY-MM-DD hh:MM:ss格式
 *@return: string
 */
export const dateTimeFormat = val => {
  let hour = val.getHours()
  hour = hour.toString()
  if (hour.length < 2) {
    hour = '0' + hour
  }

  let minute = val.getMinutes()
  minute = minute.toString()
  if (minute.length < 2) {
    minute = '0' + minute
  }

  let second = val.getSeconds()
  second = second.toString()
  if (second.length < 2) {
    second = '0' + second
  }

  return (
    val.getFullYear() +
    '-' +
    pad(val.getMonth() + 1) +
    '-' +
    pad(val.getDate()) +
    ' ' +
    hour +
    ':' +
    minute +
    ':' +
    second
  )
}

/*
 *标准时间转换成YY-MM-DD格式
 *@return: string
 */
export const dateFormat = val => {
  return (
    val.getFullYear() + '-' + pad(val.getMonth() + 1) + '-' + pad(val.getDate())
  )
}

/**
 * 转换补0
 * @return: string
 */
export const pad = n => {
  return n < 10 ? '0' + n : n
}

/**
 * @msg: 获取系统当前时间
 * date 时间
 *  fmt 时间格式
 * @return: string
 */
export const formatDate = (date, fmt) => {
  let time = ''
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'H+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    time = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      time = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return time
}

/*2019-7-1：计算时间差*/
export const dataDiff = sDate2 => {
  var sDate1 = getCurData() //系统当前时间
  //sDate2=formatDate(sDate2,"yyyy-MM-dd");
  var aDate, oDate1, oDate2, iDays
  aDate = sDate1.split('-')
  oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]) //转换为yyyy-MM-dd格式
  aDate = sDate2.split('-')
  oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])
  iDays = parseInt((oDate2 - oDate1) / 1000 / 60 / 60 / 24) //把相差的毫秒数转换为天数
  return iDays //返回相差天数
}

export const dateCompare = (startDate, endDate) => {
  //比较俩个日期时间大小
  let startDateTemp = new Date(startDate.replace('-', '/'))
  let endDateTemp = new Date(endDate.replace('-', '/'))
  return startDateTemp > endDateTemp
}

/**
 * 校验手机号是否正确
 * phone 手机号
 */

export const verifyPhone = phone => {
  const reg = /^1[34578][0-9]{9}$/
  const _phone = phone.toString().trim()
  let toastStr =
    _phone === '' ? '手机号不能为空~' : !reg.test(_phone) && '请输入正确手机号~'
  return {
    errMsg: toastStr,
    done: !toastStr,
    value: _phone
  }
}

export const verifyStr = (str, text) => {
  const _str = str.toString().trim()
  const toastStr = _str.length ? false : `请填写${text}～`
  return {
    errMsg: toastStr,
    done: !toastStr,
    value: _str
  }
}

// 截取字符串
export const sliceStr = (str, sliceLen) => {
  if (!str) {
    return ''
  }
  let realLength = 0
  const len = str.length
  let charCode = -1
  for (let i = 0; i < len; i++) {
    charCode = str.charCodeAt(i)
    if (charCode >= 0 && charCode <= 128) {
      realLength += 1
    } else {
      realLength += 2
    }
    if (realLength > sliceLen) {
      return `${str.slice(0, i)}...`
    }
  }

  return str
}

/**
 * JSON 克隆
 * jsonObj json对象
 * return 新的json对象
 */
export function objClone(jsonObj) {
  let buf
  if (jsonObj instanceof Array) {
    buf = []
    let i = jsonObj.length
    while (i--) {
      buf[i] = objClone(jsonObj[i])
    }
    return buf
  } else if (jsonObj instanceof Object) {
    buf = {}
    for (let k in jsonObj) {
      buf[k] = objClone(jsonObj[k])
    }
    return buf
  } else {
    return jsonObj
  }
}

export function getDictName(value, dictArr) { //转换===任务字典
  if (value != null) {
    let arr = dictArr.filter(item => item.value == value)
    return arr[0].name
  } else {
    return ''
  }
}

//获取当前月份后面12个月所有月份
export function getAllMonth() {
  var dataArr = [];
  var data = new Date();
  var year = data.getFullYear();
  data.setMonth(data.getMonth() + 1, 1) //获取到当前月份,设置月份
  for (var i = 0; i < 12; i++) {
    data.setMonth(data.getMonth() - 1); //每次循环一次 月份值减1
    var m = data.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    dataArr.push(data.getFullYear() + "-" + (m))
  }

  return dataArr.reverse();
}

//获取当前年份后面6年
export function getAllYears() {
  let dataArr = [];
  let date = new Date();
  dataArr.push(dateFormat(date))
  for (let i = 1; i < 6; i++) {
    date.setYear(date.getFullYear() - 1);
    dataArr.push(dateFormat(date, 'yyyy-MM-dd'))
  }
  return dataArr.reverse()
}
export function setYearList() {
  let dataArr = [];
  let arr2 = [];
  let date = new Date();
  dataArr.push(dateFormat(date));
  for (let i = 1; i < 6; i++) {
    date.setYear(date.getFullYear() - 1);
    dataArr.push(dateFormat(date, "yyyy-MM-dd"));
  }
  for (let i = 0; i < dataArr.length; i++) {
    let data = {};
    data.name = dataArr[i].substr(0, 4);
    data.value = dataArr[i].substr(0, 4);
    arr2.push(data);
  }
  return arr2.reverse();
}
//判断手机是否是iphone以上手机
export const isIphonex = () => {
  if (typeof window !== 'undefined' && window) {
    return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
  }
  return false;
};
/**
 * 数组递归格式化（多维数组转化为一维数组
 * @param {*} data
 */
export const jsonFormat = (data) => {
  let arr = [];
  for (let item of data) {
    if (item.children && item.children.length > 0) {
      arr = arr.concat(jsonFormat(item.children));
    }
    item.children = [];
    arr.push(item);
  }
  return arr;
};